"use client";

import { createContext, useContext } from "react";
import type { Environment, Theme } from "../../../types";

export interface AppLauncherContextValue {
  env: Environment;
  theme: Theme;
  isMobile: boolean;
  open: boolean;
  domain?: string;
  close: () => void;
}

export const AppLauncherContext = createContext<AppLauncherContextValue | null>(
  null,
);

export function useAppLauncherContext() {
  const ctx = useContext(AppLauncherContext);
  if (!ctx) {
    throw new Error(
      "AppLauncher compound components must be used within <AppLauncher>",
    );
  }
  return ctx;
}
